// player.play() returns a promise. It rejects with an AbortError when the
// pending play is interrupted by pause(), a new source or dispose() (video.js
// calls load() on the media element while disposing). Layers do that on purpose
// while switching sources, so only other failures (e.g. autoplay policy) are logged.
// Resolves whether playback actually started.
export function play(
    context: string,
    name: string,
    player: any,
): Promise<boolean> {
    return Promise.resolve(player.play()).then(
        () => true,
        (error: unknown) => {
            if ((error as Error)?.name !== 'AbortError') {
                console.warn(context, name, 'play() failed', error);
            }
            return false;
        },
    );
}
